import { SVGProps, Ref, forwardRef } from 'react';

export const BankFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M3.367 6.7v5.304l.85-.004h1.305V6.7h1.4V12h2.155V6.7h1.4V12h1.306q.475-.001.85.004V6.7h1.4v5.485c.132.05.25.113.362.192.523.378.743 1.038 1.183 2.358L16 16H0l.422-1.265c.412-1.237.632-1.895 1.089-2.283l.094-.075q.165-.118.362-.19V6.7z"
                fill="currentColor"
            />
            <path
                d="M8 .022c.133-.053.26 0 .513.158L16 3.3v.666c0 .575 0 .89-.195 1.139-.196.142-.51.142-1.138.195H1.333C.705 5.247.391 5.247.195 5.105 0 4.856 0 4.541 0 3.966V3.3L7.487.18C7.74.022 7.867-.03 8 .022"
                fill="currentColor"
            />
        </g>
    </svg>
));
BankFilledSize16Glyph.displayName = 'BankFilledSize16Glyph';
